/**
 * Build-Time Data Loader
 * 
 * Loads data that was injected during build time
 * This provides instant data without client-side fetching
 */

/**
 * Get build-time data from window.__BUILD_DATA__
 * This data is injected into index.html during build
 */
export function getBuildData() {
  if (typeof window === 'undefined') {
    return null;
  }
  
  // Check for injected data
  if (window.__BUILD_DATA__ && window.__BUILD_DATA__.homepage) {
    return window.__BUILD_DATA__.homepage;
  }
  
  return null;
}

/**
 * Load build-time data with fallback
 * Tries injected data first, then falls back to JSON file
 */
export async function loadBuildData() {
  // Try injected data first (fastest - already in HTML)
  const injected = getBuildData();
  if (injected) {
    console.log('✅ Using build-time data from HTML injection');
    return injected;
  }
  
  // Fallback: fetch from JSON file
  try {
    const response = await fetch('/build-data.json');
    if (response.ok) {
      const data = await response.json();
      if (data.homepage) {
        console.log('✅ Using build-time data from JSON file');
        return data.homepage;
      }
    }
  } catch (error) {
    console.warn('⚠️ Could not load build data from JSON:', error);
  }
  
  return null;
}

/**
 * Check if build-time data is available
 */
export function hasBuildData() {
  return getBuildData() !== null;
}

